import type { Column, Row } from '../../Table';
import type { AttachCandidate } from './types';
import type { KindConfig } from './kindConfig';
import { formatRelativeTime } from '../../../lib/relativeTime';

export function buildColumns(config: KindConfig): Column[] {
  return config.tableColumns.map((spec) => ({ key: spec.key, label: spec.label, type: 'text', editable: false }));
}
export function candidateToRow(c: AttachCandidate): Row {
  return {
    id: c.id,
    title: c.title || 'Untitled',
    type: c.typeLabel ?? '—',
    owner: c.ownerName ?? '—',
    updated: c.updatedAt ? formatRelativeTime(c.updatedAt) : '—',
  };
}
